import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  containerClass?: string;
}
export function Section({
  children,
  className = '',
  id,
  containerClass = ''
}: SectionProps) {
  return <section id={id} className={`py-20 md:py-32 relative overflow-hidden ${className}`} data-id="element-298">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className={`max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 ${containerClass}`} data-id="element-299">
        {children}
      </motion.div>
    </section>;
}